import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        background: "#1e3b6e",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        flexDirection: "column",
      }}
    >
      <Typography fontSize={150}>404</Typography>
      <Typography fontSize={50}>Page not found</Typography>
      <Typography fontSize={20}>
        The page you're looking for can't be found
      </Typography>
      <Button
        onClick={() => navigate("/inspection-details")}
        variant="contained"
        color="error"
        sx={{ mt: 2 }}
      >
        Go back to hame
      </Button>
    </Box>
  );
}
